import { createAction, props } from '@ngrx/store';
import { Installer } from '../../domains/users';


export const showEnhancedInstallerProfile = createAction(
  '[CORE: Installer Profile] (Show) Enhanced Installer Profile',
  props<{ installer: Installer }>(),
);

